import React, { useState, useEffect } from "react";
import { useGlobalContext } from "store/contexts/globalContext";
import CreateTeamDialogButton from "components/CreateTeam";
import JoinTeamDialogButton from "components/JoinTeam";
import TeamCard from "components/TeamCard";
import Loader from "components/Loader";
import { useSelector, useDispatch } from "react-redux";
import SearchInputField from "components/SearchInputField";
import { ReactComponent as SearchIcon } from "assets/img/icons/search.svg";
import TeamSort from "components/TeamSort";
import * as appActions from "reteamStore/actions";

export default () => {
  const { loading, filterTeam } = useGlobalContext();
  const dispatch = useDispatch();
  const { teams, searchedName } = useSelector((state) => state.teamsReducer);
  const [searchedTeam, setTeamSearch] = useState(false);

  const handleSearched = async (searchValue) => {
    await filterTeam({ name: searchValue });
    if (!searchedTeam) setTeamSearch(true);
  };

  useEffect(() => {
    return async () => {
      await resetSearched();
    };

    //eslint-disable-next-line
  }, []);

  const resetSearched = async () => {
    await handleSearched();
    await filterTeam({ name: null });
    await dispatch(appActions.clearSearchTName());
    if (searchedTeam) setTeamSearch(false);
  };

  return (
    <div className="col-lg-9 middle-content px-3">
      <div className="team-header">
        <div className="team-buttons">
          <CreateTeamDialogButton />
          <JoinTeamDialogButton />
        </div>
        <div className="team-search-input">
          <SearchInputField
            value={searchedName}
            handleSearched={handleSearched}
            placeholder={"Search Team By Name"}
            Icon={SearchIcon}
          />
          <TeamSort filterTeam={filterTeam} />
        </div>
      </div>
      {searchedTeam && (
        <div className="resetTeamSearch">
          <span onClick={resetSearched} className="resetIcon">
            Reset
          </span>
        </div>
      )}
      <div className="teams-cards">
        <div style={{ display: "flex", justifyContent: "center" }}>
          {loading && <Loader />}
        </div>
        {!loading && (
          <div className="row teamRow">
            {teams?.map((team) => (
              <TeamCard key={parseInt(team.id)} team={team} />
            ))}
          </div>
        )}
        {searchedTeam && teams?.length === 0 && !loading && (
          <div className="noTeamText">
            <span>Unfortunately, there is no team related to this search.</span>
          </div>
        )}
        {!searchedTeam && teams?.length === 0 && !loading && (
          <div className="noTeamText">
            <span>Currently you do not have any teams</span>
          </div>
        )}
      </div>
    </div>
  );
};
